<script setup lang="ts">
import type { HouseIncludedService, Locale } from 'lc-services/types'
import { includedServicesIcons } from 'assets/js/includedServicesIcons'

const { locale, t } = useI18n()
const { trackEvent } = useTracking()

const props = defineProps<{
  houseId: string
  houseIncludedServices: HouseIncludedService[]
}>()

const isCollapseOpen = ref(false)

const buttonCollapseText = ref({
  open: t('action.seeLess'),
  close: t('action.seeMore'),
})

const handleOpenCollapse = () => {
  trackEvent({
    event: 'product_page_included_services',
    house_id: props.houseId,
  })
}

const visibleServices = computed(() => {
  return props.houseIncludedServices?.slice(0, 4)
})

const hiddenServices = computed(() => {
  return props.houseIncludedServices?.slice(4)
})

const getIconName = (identifier: string) => {
  return (
    includedServicesIcons.find((i) => i.identifier === identifier)?.icon ||
    'sparkles'
  )
}
</script>

<template>
  <div v-if="houseIncludedServices?.length">
    <h2 class="m-0 mb-5 text-2xl md:mb-6">
      {{ $t('house.includedServices.title') }}
    </h2>
    <div class="flex flex-wrap items-center">
      <div
        v-for="service in visibleServices"
        :key="service.identifier"
        class="mb-4 flex w-full items-center md:w-1/2"
      >
        <BaseIcon
          class="mr-2 shrink-0"
          :name="getIconName(service.identifier)"
          :size="2"
        />
        <span>
          {{ service.name[locale as Locale] }}
        </span>
      </div>
    </div>
    <BaseCollapse
      v-if="houseIncludedServices.length > 4"
      v-model="isCollapseOpen"
      :button-text="buttonCollapseText"
      color="black"
      content-position="up"
      @update:model-value="handleOpenCollapse"
    >
      <div class="flex flex-wrap items-center">
        <div
          v-for="service in hiddenServices"
          :key="service.identifier"
          class="mb-4 flex w-full items-center md:w-1/2"
        >
          <BaseIcon
            class="mr-2 shrink-0"
            :name="getIconName(service.identifier)"
            :size="2"
          />
          <span>
            {{ service.name[locale as Locale] }}
          </span>
        </div>
      </div>
    </BaseCollapse>
  </div>
</template>
